export default __webpack_public_path__ + "static/media/bg-apolices.6897e8df.webp";